/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Structure:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
==========================================================================================*/

export default [
  {
    url: "/user/add-skill",
    name: "Add new skill",
    slug: "user",
    icon: "PlusCircleIcon",
    i18n: "Addnewskill",
    // i18n: "Add new skill"
  },
  {
    url: "/user/home",
    name: "Home",
    slug: "user-home",
    icon: "HomeIcon",
    i18n: "home_title",
  },
  {
    url: "/user/coaching-experience",
    name: "Coaching Experience",
    slug: "user",
    icon: "SmileIcon",
    i18n: "coachingExperiences",
    // i18n: "Add Coaching Effectiveness Satisfaction"
  },
  {
    url: "/user/consultants",
    name: "Consultants",
    slug: "user-consultants-menu",
    icon: "BriefcaseIcon",
    i18n: 'Consultants'
  },
  {
    url: "/user/my-rater/rater-list",
    name: "My Raters",
    slug: "my-rater",
    icon: "SendIcon",
    i18n: "MyRaters",
  },
  {
    url: "/user/training-center/view",
    name: "Training Center",
    slug: "training-center",
    icon: "HelpCircleIcon",
    i18n: "trainingCenter"
  },
];
